import React, { DOMAttributes, MutableRefObject, useCallback } from 'react';
import { getRailPositionFromXPos, getSliderValueFromRailPosition } from '../sliderUtils';
import { SliderProps } from '../Slider';

type Props = SliderProps & {
    currentValue: number;
    setCurrentValue: (currentValue: number) => void;
    sliderHandleContainerRectRef: MutableRefObject<DOMRect | null>;
};

const useSliderRailEventHandlers = (props: Props): DOMAttributes<HTMLDivElement> => {
    const { checkpoint, currentValue, setCurrentValue, sliderHandleContainerRectRef, min, max } = props;

    const onClick = useCallback(
        (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            if (!sliderHandleContainerRectRef.current) return;

            const railPosition = getRailPositionFromXPos(event.pageX, sliderHandleContainerRectRef.current);

            // If there is a checkpoint and the user clicked on a position that is over the checkpoint, then stop at
            // the checkpoint first
            if (
                checkpoint &&
                ((currentValue < checkpoint && railPosition > 0.5) || (currentValue > checkpoint && railPosition < 0.5))
            ) {
                setCurrentValue(checkpoint);
                return;
            }

            const newValue = getSliderValueFromRailPosition(railPosition, props);
            setCurrentValue(newValue);
        },
        [currentValue, checkpoint, min, max],
    );

    return { onClick };
};

export default useSliderRailEventHandlers;
